import { FEATURE_FLAG_SUCCESS, FEATURE_FLAG_REQUEST, FEATURE_FLAG_FAILURE } from '../actions/feature_flag'

export function featureFlag(
  state = {
    isFetching: false,
    data: {},
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case FEATURE_FLAG_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }

    case FEATURE_FLAG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.response,
      }
    case FEATURE_FLAG_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    default:
      return state
  }
}
